/* eslint-disable */
import Splide from '@splidejs/splide';
'use strict';

const SplideExample = {
    init: function() {
        if (!document.querySelector('.splide')) {
            return;
        }

        this.splideMount();
    },

    splideMount() {
        let main = new Splide('.splide', {
            perPage: 6,
            rewind: true,
            pagination: false,
            breakpoints: {
                1600: {
                    perPage: 5,
                },
                1199: {
                    perPage: 4,
                },
                767: {
                    perPage: 3,
                },
                640: {
                    perPage: 2,
                },
                400: {
                    perPage: 1
                },
            },
        });
        main.mount();
    }
};

export default SplideExample;